import SameDayIcon from 'svgs/redesign/sameday.svg';
import TrustedIcon from 'svgs/redesign/trusted.svg';
import HelpIcon from 'svgs/redesign/help.svg';
import FlexibleIcon from 'svgs/redesign/calendar.svg';
import RatesIcon from 'svgs/redesign/dollar.svg';
import CompletionIcon from 'svgs/redesign/completion.svg';

import * as styles from './index.module.scss';

const HeroBullets = (props) => (
  <div className={`${styles['bullets-container']} ${props.theme ? styles[props.theme] : ''}`}>
    <div className={styles['bullet-container']}>
      <SameDayIcon />
      <label>Quick Same Day Service</label>
    </div>
    <div className={styles['bullet-container']}>
      <TrustedIcon />
      <label>Trusted Local {props.category?.name_plural || 'Experts'}</label>
    </div>
    <div className={styles['bullet-container']}>
      <HelpIcon />
      <label>
        <strong>24-Hour</strong> Service Available
      </label>
    </div>
    <div className={styles['bullet-container']}>
      <FlexibleIcon />
      <label>Flexible Appointments</label>
    </div>
    <div className={styles['bullet-container']}>
      <RatesIcon />
      <label>Competitive Pricing</label>
    </div>
    <div className={styles['bullet-container']}>
      <CompletionIcon />
      <label>
        <strong>100%</strong> Satisfaction
      </label>
    </div>
  </div>
);

export default HeroBullets;
